
import grilleService from "../../../services/grille.service";
import { SET_MESSAGE } from "../message/type";
import {
  UPDATE_GRILLE_SUCCESS,
  UPDATE_GRILLE_FAIL,
  LIST_GRILLE_FAIL,
  LIST_GRILLE_SUCCESS,
  CREATEGRILLE_FAIL,
  CREATEGRILLE_SUCCESS,
  LIST_GRILLE_Desactiver_SUCCESS,
  LIST_GRILLE_Desactiver_FAIL,
  ONE_GRILLE_SUCCESS,
  DEACTIVATE_GRILLE_FAIL,
  ONE_GRILLE_FAIL,
  DEACTIVATE_GRILLE_SUCCESS,
  OPEN_GRILLE_SUCCESS,
  SEARCH_GRILLE_SUCCESS,
  SEARCH_GRILLE_FAIL,
  REMOVE_CRITERIA_VALUES_SUCCESS,
  CLEAR_DATA_GRILLE,
  LIST_GRIDS_SUCCESS,
  LIST_All_GRIDS_FAIL
} from "./type";

export const createGrille = (data) => (dispatch) => {
  return grilleService.createGrilles(data).then(
    (response) => {
      dispatch({
        type: CREATEGRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });
     return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CREATEGRILLE_FAIL,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getGrillesByTenant = (page, size) => (dispatch) => {
  return grilleService.getGrillesByTenantId(page, size).then(
    (response) => {
      dispatch({
        type: LIST_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getMesGrilles = (page, size) => (dispatch) => {
  return grilleService.getMesGrilles(page, size).then(
    (response) => {
      dispatch({
        type: LIST_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getMesGridsDesactivee = (page, size) => (dispatch) => {
  return grilleService.getMesGridsDesactivee(page, size).then(
    (response) => {
      dispatch({
        type: LIST_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const allGrillesDesactiver = (page, size) => (dispatch) => {
  return grilleService.allGrillesDesactiver(page, size).then(
    (response) => {
      dispatch({
        type: LIST_GRILLE_Desactiver_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_GRILLE_Desactiver_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const AllGrids = () => (dispatch) => {
  return grilleService.getAllGrids().then(
    (response) => {
      dispatch({
        type: LIST_GRIDS_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {

      dispatch({
        type: LIST_All_GRIDS_FAIL,
      });

      return Promise.reject();
    }
  );

}
export const getAllGrilles = (page, size) => (dispatch) => {
  return grilleService.allGrilles(page, size).then(
    (response) => {
      dispatch({
        type: LIST_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getOneGrilles = (grilleId) => (dispatch) => {
  return grilleService.oneGrille(grilleId).then(
    (response) => {
      dispatch({
        type: ONE_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ONE_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const updateGrille = (grilleId, data) => (dispatch) => {
  return grilleService.updateGrilles(grilleId, data).then(
    (response) => {
      dispatch({
        type: UPDATE_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: UPDATE_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const deactivateGrid = (grilleId) => (dispatch) => {
  return grilleService.DeactivateGrille(grilleId).then(
    (response) => {
      dispatch({
        type: DEACTIVATE_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: DEACTIVATE_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const HandelGrille = (datagrilleselecet) => {
  return {
    type: OPEN_GRILLE_SUCCESS,
    payload: { datagrilleselecet },
  };
};
export const ClearGrille = () =>{
  return {
    type: CLEAR_DATA_GRILLE,
    payload: {},
  };
}

export const searchGrilles = (page, size, status, keybord) => (dispatch) => {
  return grilleService.search(page, size,status, keybord).then(
    (response) => {
      dispatch({
        type: SEARCH_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SEARCH_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const searchMesGrids = (page, size, status, keybord) => (dispatch) => {
  return grilleService.searchMygrids(page, size,status, keybord).then(
    (response) => {
      dispatch({
        type: SEARCH_GRILLE_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SEARCH_GRILLE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const removeCriteriaValues = (data) => {
  return {
    type: REMOVE_CRITERIA_VALUES_SUCCESS,
    payload: data,
  };
};
